module.exports = __webpack_public_path__ + "img/profile_picture.582d48d0.png";